


















import { Vue, Component } from 'vue-property-decorator';
import CommonDialog from '../../../components/organisms/CommonDialog.vue';
import DialgoHeader from './DialgoHeader.vue';

import { LessonListDTO } from '../../../../src_server/entity/dto/LessonListDTO';
import { Session } from '../../../utils/Session';
import { MessageDialog } from '../../../utils/MessageDialog';

import { dayjs, DTW_FORMAT_JA, DT_FORMAT, DT_FORMAT_INPUT, DT_FORMAT_JA, D_FORMAT_JA } from '../../../../src_server/common/momentExtends';
import { LessonScheduleDTO } from '../../../../src_server/entity/dto/LessonScheduleDTO';
import { ShiftTable } from '../../../../src_server/entity/generated/ShiftTable';
import ScheduleHourSetting from './ScheduleHourSetting.vue';
import { ShiftTableDTO } from '../../../../src_server/entity/dto/ShiftTableDTO';
import { LessonsService } from '../../../biz/remote/LessonsService';
import { LessonConst } from '../../../../src_server/entity/master/LessonConst';

@Component({ components: { CommonDialog, DialgoHeader, ScheduleHourSetting } })
export default class LessonRequestDialog extends Vue {
  private dto = new LessonListDTO();

  private schedules: LessonScheduleDTO[] = [];
  private selectedSchedules: ShiftTable[] = [];
  private selectedDt: Date = new Date();

  private get title() {
    return `予約時間指定 ${dayjs(this.selectedDt).format(D_FORMAT_JA)}`;
  }

  get teacher() {
    return this.dto.teacher;
  }
  private get schoolYear() {
    return this.dto.teacher?.target_school_year;
  }
  private get weekDay() {
    return this.dto.teacher?.work_day_of_week;
  }
  // private get isShownAll() {
  //   console.log('isShownAll', this.schedules.length, this.dto.schedules.length);
  //   return this.schedules.length === this.dto.schedules.length;
  // }

  /************************
   * ダイアログの開閉
   */
  public async show(dto: LessonListDTO, start_dt: Date) {
    this.dto = dto;
    this.selectedDt = start_dt;

    // 初期表示は10件
    this.schedules = this.filterScedule(this.dto.schedules, 10, start_dt);
    const dialog = this.$refs['LessonRequestDialog'] as CommonDialog;
    dialog.show();
  }

  public close() {
    (this.$refs['LessonRequestDialog'] as CommonDialog).hide();
  }

  /**
   * 予約の送信
   */
  async sendReservation() {
    const biz = new LessonsService();
    const requestPromises = this.selectedSchedules.map(async (s, index: number) => {
      if (!this.dto?.userAuth?.user_id) {
        await MessageDialog.systemError('先生情報', '予約依頼送信時', this.dto?.userAuth?.user_id);
        return;
      }
      if (!s.shift_table_id) {
        await MessageDialog.systemError('シフトID', '予約依頼送信時', this.dto?.userAuth?.user_id);
        return;
      }

      const start_dayjs = dayjs(s.start_time);
      const start_dt = start_dayjs.format(DT_FORMAT);
      const end_dt = start_dayjs.add(LessonConst.LESSON_TIME, 'minute').format(DT_FORMAT_INPUT);
      const result = await biz.reservation(Session.getSessionUserId(), this.dto.userAuth.user_id, start_dt, end_dt, s.shift_table_id);

      if (result.hasError) {
        await MessageDialog.alert(`${result.status}, ${result.errorDescription}, ${result.errorExpandedData}`);
        return; // continue next
      }

      const reservationResult = result.data;
      reservationResult.reservatedLessons;
      if (reservationResult.reservatedLessons.length > 0) {
        const lesson = reservationResult.reservatedLessons[0];
        await MessageDialog.alert(`${dayjs(lesson.start_dt).format(DTW_FORMAT_JA)}の予約依頼を先生に送信しました。確定までしばらくお待ちください。`);
      }
      if (reservationResult.duplicateLessons.length > 0) {
        const lesson = reservationResult.duplicateLessons[0];
        await MessageDialog.alert(`${dayjs(lesson.start_dt).format(DTW_FORMAT_JA)}の予約依頼はすでに予約が入っていて予約できませんでした。`);
      }
    });

    await Promise.all(requestPromises);
    this.close();
  }

  /**
   * スケジュールをフィルタリング
   */
  filterScedule(list: ShiftTableDTO[], size: number, start_dt: Date) {
    const baseDate = dayjs(start_dt);
    console.log(baseDate);
    return (
      this.dto.schedules
        // .sort((a: ShiftTableDTO, b: ShiftTableDTO) => {
        //   return dayjs(a.shiftTable.start_time).diff(dayjs(b.shiftTable.start_time));
        // })
        .filter((s) => {
          const scheduleDate = dayjs(s.shiftTable.start_time);
          const diff = scheduleDate.diff(baseDate);
          return diff === 0 ? true : diff > 0 ? true : false;
          // return baseDate.diff(scheduleDate);
        })
        // 当日のスケジュールのみ
        .filter((s) => {
          const scheduleDate = dayjs(s.shiftTable.start_time);
          return Math.abs(scheduleDate.diff(start_dt, 'd')) <= 1;
        })
        // .slice(0, size)
        .map((s) => {
          const dto = new LessonScheduleDTO();
          dto.shiftTable = s.shiftTable;
          dto.lesson = s.lesson;
          dto.teacher = this.dto.teacher;
          return dto;
        })
    );
  }

  /**
   * もっと見る
   */
  more() {
    this.schedules = this.filterScedule(this.dto.schedules, this.dto.schedules.length, this.selectedDt);
  }

  /***********************
   * 予定が選択された時のハンドラ
   */
  private async selectTimes(changedItem: { selected: boolean; overWriteShift: ShiftTable }) {
    if (!changedItem.overWriteShift.shift_table_id) {
      await MessageDialog.systemError('シフトテーブルID', '予約対象予定選択時');
      return;
    }

    if (changedItem.selected) {
      this.selectedSchedules.push(changedItem.overWriteShift);
    } else {
      // キーを削除
      this.selectedSchedules.splice(
        this.selectedSchedules.findIndex((s) => s.shift_table_id === changedItem.overWriteShift.shift_table_id),
        1
      );
    }
  }
}
